(function () {
  'use strict';

  var header = document.querySelector('[data-hymns-header]');
  if (!header) return;

  /* ---------------------------------------------------------------------
     Full-bleed mega menu: needs the header's real rendered height (bar +
     any announcement marquee) so its fixed-position panel lines up exactly
     under the header regardless of viewport width or announce-bar state.
  --------------------------------------------------------------------- */
  function updateHeaderHeightVar() {
    document.documentElement.style.setProperty('--hymns-header-total-h', header.offsetHeight + 'px');
  }
  updateHeaderHeightVar();
  window.addEventListener('resize', updateHeaderHeightVar, { passive: true });

  /* ---------------------------------------------------------------------
     Sticky header: transparent over hero, frosted-white once scrolled
  --------------------------------------------------------------------- */
  var SCROLL_THRESHOLD = 60;

  function updateScrollState() {
    if (window.scrollY > SCROLL_THRESHOLD) {
      header.classList.add('is-scrolled');
      header.classList.remove('is-hero');
    } else {
      header.classList.remove('is-scrolled');
      if (header.hasAttribute('data-transparent-hero')) {
        header.classList.add('is-hero');
      }
    }
  }

  if (header.hasAttribute('data-transparent-hero')) {
    header.classList.add('is-hero');
  }
  updateScrollState();
  window.addEventListener('scroll', updateScrollState, { passive: true });

  /* ---------------------------------------------------------------------
     Desktop mega menu / dropdown / Stockist — explicit toggle control.
     The nav link itself (Shop All, Collection, ...) is left alone so it
     always navigates normally on click or Enter; a separate chevron
     button (or, for Stockist, the whole trigger — it has no destination
     page) opens/closes the panel and carries aria-expanded so screen
     reader and keyboard users get the same disclosure semantics mouse
     users get for free via :hover. Hover and :focus-within (in the CSS)
     still work independently of this for pointer/keyboard users who
     never click.
  --------------------------------------------------------------------- */
  function closeAllNavItems(except) {
    document.querySelectorAll('.hymns-header__nav-item.is-open').forEach(function (el) {
      if (el === except) return;
      el.classList.remove('is-open');
      var btn = el.querySelector('.hymns-header__caret-btn, .hymns-header__nav-trigger');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  document.querySelectorAll('.hymns-header__caret-btn, .hymns-header__nav-trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.hymns-header__nav-item');
      if (!item) return;
      var isOpen = item.classList.contains('is-open');
      closeAllNavItems(isOpen ? null : item);
      item.classList.toggle('is-open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.hymns-header__nav-item')) closeAllNavItems();
  });

  /* ---------------------------------------------------------------------
     Search: now uses the theme's own native search drawer
     (aria-controls="drawer-search-form" on the header/drawer search links),
     so no custom open/close JS is needed here any more.
  --------------------------------------------------------------------- */

  /* ---------------------------------------------------------------------
     Mobile drawer
  --------------------------------------------------------------------- */
  var drawer = document.querySelector('[data-hymns-drawer]');
  var drawerOverlay = document.querySelector('[data-hymns-drawer-overlay]');
  var drawerOpenBtn = document.querySelector('[data-hymns-drawer-open]');
  var drawerCloseBtns = document.querySelectorAll('[data-hymns-drawer-close]');

  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    drawerOverlay.hidden = false;
    /* Removing [hidden] and adding .is-open in the same animation frame can
       leave the browser without a committed "closed" state to transition
       from — it then resolves the transform transition to a bogus,
       partially-off-screen value instead of animating cleanly to open
       (seen live: the drawer got stuck ~1/3 off-screen, which also broke
       touch-scrolling inside it since part of its box sat outside the
       viewport). A nested rAF forces a full paint of the closed state
       first, so the transition always has a real starting point. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        drawerOverlay.classList.add('is-open');
      });
    });
    document.body.style.overflow = 'hidden';
    drawerOpenBtn && drawerOpenBtn.setAttribute('aria-expanded', 'true');
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawerOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
    drawerOpenBtn && drawerOpenBtn.setAttribute('aria-expanded', 'false');
    setTimeout(function () {
      drawer.hidden = true;
      drawerOverlay.hidden = true;
    }, 380); /* matches .hymns-drawer's transition duration in header.css */
  }
  if (drawerOpenBtn) drawerOpenBtn.addEventListener('click', openDrawer);
  drawerCloseBtns.forEach(function (btn) { btn.addEventListener('click', closeDrawer); });
  if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);

  /* ---------------------------------------------------------------------
     Cart — we no longer run our own cart drawer. It used to open
     *alongside* the theme's own native cart drawer (sections/cart-drawer.liquid,
     <dialog id="CartDrawer">, rendered site-wide) every time something was
     added to cart, so shoppers saw two cart panels stacked at once. Our
     cart icon/link now just points at that same theme drawer via
     aria-controls="CartDrawer" (see header.liquid and
     header-mobile-drawer.liquid), matching the pattern the theme's own
     mobile toolbar cart button already uses. All this does now is keep our
     header's cart-count badge in sync, and make sure our own nav drawer
     gets out of the way when the cart is opened from inside it.
  --------------------------------------------------------------------- */
  var cartCountEls = document.querySelectorAll('[data-hymns-cart-count]');
  var cartTriggers = document.querySelectorAll('[aria-controls="CartDrawer"]');

  function updateCartCount(count) {
    cartCountEls.forEach(function (el) {
      el.textContent = count;
      if (count === 0) {
        el.setAttribute('data-zero', '');
      } else {
        el.removeAttribute('data-zero');
      }
    });
  }

  function syncCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return cart;
      });
  }

  cartTriggers.forEach(function (el) {
    el.addEventListener('click', function () { closeDrawer(); });
  });

  // Initial cart-count sync, and again after anything gets added to cart
  // elsewhere on the site (the theme's own drawer handles opening itself).
  syncCartCount();

  document.body.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches('form[action^="/cart/add"]')) {
      setTimeout(syncCartCount, 400);
    }
  });

  /* Escape key closes any open overlay, including nav dropdowns/mega menu */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer();
      closeAllNavItems();
    }
  });
})();
